import React, {Fragment, useEffect} from 'react';

import '../../App.css';
import {Outlet, useMatches, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../feature/tools";
import {Button, Col, Flex, Modal, Row, Segmented, Space, Tooltip, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAngleLeft,
    faGrip,
    faList,
    faPlus
} from "@fortawesome/free-solid-svg-icons";
import {Act, Chapter} from "../../feature/project/story";
import {AddActModal} from "./AddActModal";
import {Status} from "../../feature/project/status";
import {deleteAct, fetchAct, saveAct} from "../../feature/project/actSlice";
import {fetchChapters, saveChapter} from "../../feature/project/chapterSlice";
import {AddChapterModal} from "../chapter/AddChapterModal";
import Chapters from "../chapter/Chapters";
import {useCookies} from "react-cookie";
import {ViewMode} from "../common/ViewMode";
import {EntityDetails} from "../common/EntityDetails";
import Title from "antd/es/typography/Title";
import {editorRoles, WithUserPermission} from "../common/WithUserPermission";

const {confirm} = Modal;

const ActDetails = () => {
        const dispatch = useAppDispatch()
        const navigate = useNavigate()
        const [cookies, setCookie] = useCookies(['chapterView'])
        const {actId, projectId, storyId} = useParams()
        const matches = useMatches()
        const act = useAppSelector(state => state.acts.act)
        const project = useAppSelector(state => state.projects.project)
        const status = useAppSelector(state => state.acts.status)
        const chaptersStatus = useAppSelector(state => state.chapters.status)
        const [modal, setModal] = React.useState(false)
        const [actModal, setChapterModal] = React.useState(false)

        useEffect(() => {
            if (projectId && actId && (status == Status.Idle || act?.id !== parseInt(actId))) {
                dispatch(fetchAct({projectId: parseInt(projectId), actId: parseInt(actId)}))
            }
        }, [status, projectId, actId, dispatch])

        useEffect(() => {
            if (projectId && actId && (chaptersStatus === Status.Idle || act?.id !== parseInt(actId))) {
                dispatch(fetchChapters({projectId: parseInt(projectId), actId: parseInt(actId)}))
            }
        }, [chaptersStatus, projectId, storyId, dispatch])

        const showDeleteConfirm = () => {
            confirm({
                title: 'Delete Act',
                content: 'Are you sure you want to delete this act?',
                icon: <></>,
                okText: 'Yes, delete',
                okButtonProps: {danger: true, type: 'primary'},
                cancelText: 'No',
                onOk() {
                    if (!actId || !projectId) return
                    dispatch(deleteAct({projectId: parseInt(projectId), actId: parseInt(actId)}))
                    navigate(`/projects/${projectId}/stories/${storyId}`)
                },
            });
        };

        return (
            <Fragment>{
                matches[matches.length - 1].pathname.includes('/chapters') ? <Outlet/> : <>
                    <Row style={{height: "100%"}}>
                        <Col span={act ? 16 : 24} style={{height: "100%"}}>
                            <Flex justify={'space-between'}>

                                <Space>
                                    <Button type={'text'}
                                            onClick={() => navigate(`/projects/${projectId}/stories/${storyId}`)}
                                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                                    <Title level={4} style={{margin: 0}}>Chapters</Title>
                                </Space>
                                <WithUserPermission roles={editorRoles}>
                                    <Space>
                                        <Tooltip title="Add Chapter">
                                            <Button icon={<FontAwesomeIcon icon={faPlus}/>}
                                                    onClick={() => setChapterModal(true)}>Add
                                                Chapter</Button>
                                        </Tooltip>
                                    </Space>
                                </WithUserPermission>
                            </Flex>
                            <Chapters/>
                        </Col>
                        {act ? <Col span={8} style={{height: "100%"}}>
                            <EntityDetails
                                simple={true}
                                entity={act}
                                onDeleteClick={() => {
                                    showDeleteConfirm()
                                }}
                                onEditClick={() => setModal(true)}
                            />
                        </Col> : ''}
                    </Row>
                    {act ?
                        <AddActModal
                            act={act}
                            visible={modal}
                            onCancel={() => setModal(false)}
                            onSave={(chapter: Act) => {
                                if (project) {
                                    dispatch(saveAct({projectId: project.id, act: chapter}))
                                }
                                setModal(false)
                            }}
                        /> : ''}
                    <AddChapterModal
                        chapter={{title: '', description: '', cover: '', tags: []}}
                        visible={actModal}
                        onCancel={() => setChapterModal(false)}
                        onSave={(chapter: Chapter) => {
                            if (project && actId) {
                                chapter.actId = parseInt(actId)
                                dispatch(saveChapter({projectId: project.id, chapter: chapter}))
                            }
                            setChapterModal(false)
                        }}
                    />
                </>
            }
            </Fragment>

        );
    }
;

export default ActDetails;